import React, { Component } from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Tabs, Menu } from 'antd';
import store from 'store';
import { isQuickBIReportUrl, fetchQuickBIReportUrl } from '@/utils/util';

// styl
import './IndexTabsNavigation.styl';

class IndexTabsNavigation extends Component {
  state = {
    contextMenuIndex: '',
    contextMenuPosition: {
      clientX: '',
      clientY: '',
    },
    visiableContextMenu: false,
  };

  onClick(id) {
    this.props.updateOpenModuleId(id);
  }

  onEdit(targetKey, action) {
    // e.stopPropagation();
    if (action === 'remove') {
      // 多租户首页最后一个数据不能删除
      if (this.props.isTenant && this.props.openModule.length === 1) return;
      const index = this.props.openModule.findIndex(
        (item) => String(item.id) === String(targetKey),
      );
      this.props.removeModule(targetKey, index);
    }
  }

  onReset(item, index, e) {
    e.stopPropagation();
    const getIframe = document.querySelectorAll('.inner-iframe')[index];
    if (getIframe) {
      // 报表 URL 重新换票获取新的 accessTicket 地址，
      // item.path 存的是换票前的原始地址，不能直接用作 src
      if (isQuickBIReportUrl(item.path)) {
        fetchQuickBIReportUrl(item.path)
          .then((url) => {
            // 换票返回前 iframe 可能已被关闭
            const iframe = document.getElementById(getIframe.id);
            if (iframe) {
              iframe.setAttribute('src', url);
            }
          })
          .catch(() => {
            // 换票失败保持原页面
          });
        return;
      }
      // 针对hash路由，尾部添加随机参数不生效，在/#/前添加随机数
      if (item.path.split('?')[0].includes('/#/')) {
        const pathArr = item.path.split('/#/');
        const newPath = `${pathArr[0]}/_t=${Math.random() * 1e18}/#/${pathArr[1]}`;
        getIframe.setAttribute('src', newPath);
      } else {
        const newPath = `${item.path}&_t=${Math.random() * 1e18}`;
        getIframe.setAttribute('src', newPath);
      }
    }
  }

  componentDidMount() {
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
      if (this.state.visiableContextMenu === -1) {
        return;
      }
      this.setState({
        contextMenuPosition: {
          clientX: `${event.clientX}px`,
          clientY: `${event.clientY}px`,
        },
      });
    });

    document.addEventListener('click', () => {
      this.setState({
        visiableContextMenu: false,
      });
    });

    window.addEventListener('message', () => {
      this.setState({
        visiableContextMenu: false,
      });
    });
  }

  // 设置右击菜单
  onContextMenuFun(contextMenuIndex) {
    this.setState({
      contextMenuIndex,
      visiableContextMenu: true,
    });
  }

  hadleCloseByIndex(indexList) {
    if (this.props.isTenant && this.props.openModule.length === 1) return;
    indexList.map((index, idx) => {
      const item = this.props.openModule[index];
      setTimeout(() => {
        this.props.removeModule(item.id, index);
      }, 100 * idx)
      return index;
    })
  }

  // 关闭左侧
  closeLeft() {
    const { contextMenuIndex } = this.state;
    if (contextMenuIndex <= 0) return;
    const closeList = Array.from({length: contextMenuIndex}).map((item, index) => index)
    this.props.removeModuleListByIndex(closeList);
  }

  // 关闭右侧
  closeRight() {
    const { contextMenuIndex } = this.state;
    const openModule = this.props.openModule;
    const delLength = openModule.length - 1 - contextMenuIndex;
    if (delLength <= 0) return;
    const closeList = Array.from({length: delLength}).map((item, index) => item = contextMenuIndex + index + 1)
    this.props.removeModuleListByIndex(closeList);

    setTimeout(() => {
      // 判断当前tabs是否有高亮
      const newOpenModule = [...this.props.openModule];
      const openModuleOpenInfo = store.get('openModuleOpenInfo') || {};
      const openObj = newOpenModule.find(
        (item) => String(item.id) === String(openModuleOpenInfo.id),
      );
      if (!openObj) {
        this.props.updateOpenModuleId(newOpenModule[newOpenModule.length - 1].id);
      }
    }, 300)
  }

  // 关闭全部
  closeAll() {
    const openModule = this.props.openModule;
    if (openModule.length - 1 <= 0) return;
    const openModuleOpenInfo = store.get('openModuleOpenInfo') || {};
    const openIndex = openModule.findIndex(
      (item) => String(item.id) === String(openModuleOpenInfo.id),
    );
    const closeList = openModule.map((item, index) => index).filter((item, index) => index !== openIndex)
    this.props.removeModuleListByIndex(closeList);
  }

  render() {
    const {
      contextMenuIndex,
      visiableContextMenu,
      contextMenuPosition: { clientX, clientY },
    } = this.state;
    return (
      <div className="index-tabs-navigation-box">
        <div
          ref={(indexTabs) => (this.indexTabs = indexTabs)}
          className={`${
            this.props.isTenant
              ? 'index-tabs-navigation-isTenant'
              : 'index-tabs-navigation'
          }`}
        >
          <Tabs
            hideAdd
            type="editable-card"
            activeKey={String(this.props.openModuleId)}
            onChange={this.onClick.bind(this)}
            onEdit={this.onEdit.bind(this)}
            items={this.props.openModule.map((item, index) => {
              return {
                key: String(item.id),
                label: (
                  <div
                    className="customLabel"
                    onContextMenu={this.onContextMenuFun.bind(
                      this,
                      index,
                    )}
                  >
                    <span className="customLabel-title">{item.title}</span>
                    {String(this.props.openModuleId) === String(item.id) ? (
                      <SyncOutlined
                        onClick={this.onReset.bind(this, item, index)}
                        className="customLabel-reset"
                      />
                    ) : (
                      ''
                    )}
                  </div>
                ),
              };
            })}
          />

          {/* 自定义右击菜单 */}
          {this.props.isTenant && visiableContextMenu ? (
            <Menu
              className="contextMenuList"
              style={{ left: clientX, top: clientY }}
            >
              <Menu.Item onClick={() => this.hadleCloseByIndex([contextMenuIndex])}>
                关闭当前
              </Menu.Item>
              <Menu.Item onClick={() => this.closeLeft()}>关闭左侧</Menu.Item>
              <Menu.Item onClick={() => this.closeRight()}>关闭右侧</Menu.Item>
              <Menu.Item onClick={() => this.closeAll()}>关闭全部</Menu.Item>
            </Menu>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default IndexTabsNavigation;
